export default __webpack_public_path__ + "static/media/gmail.8d132248.svg";